import { render, staticRenderFns } from "./SectionWebtoon.vue?vue&type=template&id=4e696cc2&scoped=true"
import script from "./SectionWebtoon.vue?vue&type=script&lang=js"
export * from "./SectionWebtoon.vue?vue&type=script&lang=js"
import style0 from "./SectionWebtoon.vue?vue&type=style&index=0&id=4e696cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e696cc2",
  null
  
)

export default component.exports